var map = {
	"./blockchain/datasource/erc20_data_source.js": 75,
	"./blockchain/datasource/legal_data_source.js": 189,
	"./blockchain/datasource/marketplace_data_source.js": 60,
	"./blockchain/datasource/murall_data_source.js": 145,
	"./blockchain/datasource/murall_state_data_source.js": 1037,
	"./blockchain/datasource/murall_state_s3_data_source.js": 139,
	"./blockchain/datasource/nft_data_source.js": 35,
	"./blockchain/datasource/token_distribution_data_source.js": 141,
	"./blockchain/nft_data_mapper.js": 65,
	"./blockchain/read_blockchain_data.js": 192,
	"./blockchain/usecase/add_event_to_murall_state_usecase.js": 320,
	"./blockchain/usecase/allow_erc20_transfer_from_address_for_user_account_usecase.js": 194,
	"./blockchain/usecase/claim_PAINT_for_address_usecase.js": 1038,
	"./blockchain/usecase/claim_PAINT_for_claim_data_usecase.js": 326,
	"./blockchain/usecase/connect_wallet_usecase.js": 327,
	"./blockchain/usecase/fill_minted_token_usecase.js": 316,
	"./blockchain/usecase/get_all_nfts_on_sale_usecase.js": 1039,
	"./blockchain/usecase/get_erc20_balance_for_user_account_usecase.js": 328,
	"./blockchain/usecase/get_erc20_total_supply_usecase.js": 1040,
	"./blockchain/usecase/get_has_agreed_to_legal_disclaimer_usecase.js": 105,
	"./blockchain/usecase/get_is_current_network_supported_usecase.js": 74,
	"./blockchain/usecase/get_is_erc20_transfer_allowed_for_amount_from_address_for_user_account_usecase.js": 193,
	"./blockchain/usecase/get_is_erc20_transfer_allowed_from_address_for_user_account_usecase.js": 1041,
	"./blockchain/usecase/get_is_network_supported_usecase.js": 187,
	"./blockchain/usecase/get_murall_current_state_usecase.js": 140,
	"./blockchain/usecase/get_murall_state_at_token_id_usecase.js": 318,
	"./blockchain/usecase/get_murall_state_changes_for_token_ids_usecase.js": 319,
	"./blockchain/usecase/get_nft_balance_for_user_account_usecase.js": 314,
	"./blockchain/usecase/get_nft_data_for_owned_token_at_index_usecase.js": 1042,
	"./blockchain/usecase/get_nft_data_for_owned_tokens_at_index_range_usecase.js": 315,
	"./blockchain/usecase/get_nft_transaction_data_usecase.js": 313,
	"./blockchain/usecase/get_nfts_for_user_account_usecase.js": 321,
	"./blockchain/usecase/get_nfts_on_sale_for_contract_address_usecase.js": 1043,
	"./blockchain/usecase/get_nfts_on_sale_for_seller_address_usecase.js": 1044,
	"./blockchain/usecase/get_nfts_on_sale_for_user_account_usecase.js": 1045,
	"./blockchain/usecase/get_paint_token_circulating_supply_usecase.js": 329,
	"./blockchain/usecase/get_paint_token_claim_contract_initial_supply_usecase.js": 1046,
	"./blockchain/usecase/get_paint_token_cost_for_pixels_usecase.js": 325,
	"./blockchain/usecase/get_paint_token_initial_supply_usecase.js": 196,
	"./blockchain/usecase/get_paint_token_remaining_supply_usecase.js": 197,
	"./blockchain/usecase/get_seller_balance_for_user_account.js": 1047,
	"./blockchain/usecase/get_token_claim_for_address_usecase.js": 190,
	"./blockchain/usecase/get_total_murall_artists_count_usecase.js": 330,
	"./blockchain/usecase/get_total_murall_state_count_usecase.js": 188,
	"./blockchain/usecase/get_wallet_connected_state_usecase.js": 88,
	"./blockchain/usecase/notify_painted_event_usecase.js": 331,
	"./blockchain/usecase/purchase_sale_item_usecase.js": 1048,
	"./blockchain/usecase/set_pixels_on_murall_and_notify_usecase.js": 332,
	"./blockchain/usecase/set_pixels_on_murall_usecase.js": 195,
	"./blockchain/usecase/set_user_agreed_to_legal_disclaimer_usecase.js": 106,
	"./blockchain/usecase/withdraw_seller_balance_for_user_account.js": 1049,
	"./blockchain/write_transaction.js": 334,
	"./edit/paste.js": 1050,
	"./edit/selection.js": 1051,
	"./edit/undo.js": 1052,
	"./effects/abstract/css.js": 53,
	"./effects/black_and_white.js": 1053,
	"./effects/blueprint.js": 1054,
	"./effects/blur.js": 1055,
	"./effects/box_blur.js": 1056,
	"./effects/brightness.js": 1057,
	"./effects/contrast.js": 1058,
	"./effects/denoise.js": 1059,
	"./effects/dither.js": 1060,
	"./effects/dot_screen.js": 1061,
	"./effects/edge.js": 1062,
	"./effects/emboss.js": 1063,
	"./effects/enrich.js": 1064,
	"./effects/grains.js": 1065,
	"./effects/grayscale.js": 1066,
	"./effects/heatmap.js": 1067,
	"./effects/hue_rotate.js": 1068,
	"./effects/mosaic.js": 1069,
	"./effects/negative.js": 1070,
	"./effects/night_vision.js": 1071,
	"./effects/oil.js": 1072,
	"./effects/pencil.js": 1073,
	"./effects/saturate.js": 1074,
	"./effects/sepia.js": 1075,
	"./effects/shadow.js": 1076,
	"./effects/sharpen.js": 1077,
	"./effects/solarize.js": 1078,
	"./effects/tilt_shift.js": 1079,
	"./effects/vibrance.js": 1080,
	"./effects/vignette.js": 1081,
	"./effects/vintage.js": 1124,
	"./effects/zoom_blur.js": 1082,
	"./file/new.js": 1083,
	"./file/open.js": 198,
	"./file/print.js": 1084,
	"./file/quickload.js": 1085,
	"./file/quicksave.js": 1086,
	"./file/save.js": 333,
	"./file/search.js": 322,
	"./help/about.js": 1088,
	"./help/shortcuts.js": 1089,
	"./help/translate.js": 142,
	"./image/auto_adjust.js": 1090,
	"./image/color_corrections.js": 1091,
	"./image/convert_to_256_colors.js": 335,
	"./image/decrease_colors.js": 1092,
	"./image/flip.js": 1093,
	"./image/grid.js": 1094,
	"./image/histogram.js": 1095,
	"./image/information.js": 1096,
	"./image/opacity.js": 1097,
	"./image/palette.js": 1125,
	"./image/resize.js": 1098,
	"./image/rotate.js": 1099,
	"./image/size.js": 1100,
	"./image/translate.js": 1101,
	"./image/trim.js": 143,
	"./image/zoom.js": 1102,
	"./layer/clear.js": 1103,
	"./layer/composition.js": 1104,
	"./layer/delete.js": 1105,
	"./layer/differences.js": 1106,
	"./layer/duplicate.js": 1107,
	"./layer/flatten.js": 1108,
	"./layer/merge.js": 1109,
	"./layer/move.js": 1110,
	"./layer/new.js": 1111,
	"./layer/raster.js": 144,
	"./layer/rename.js": 324,
	"./layer/visibility.js": 1112,
	"./tools/borders.js": 1113,
	"./tools/color_to_alpha.js": 1114,
	"./tools/color_zoom.js": 1115,
	"./tools/content_fill.js": 1116,
	"./tools/grid.js": 1117,
	"./tools/keypoints.js": 1118,
	"./tools/replace_color.js": 1119,
	"./tools/restore_alpha.js": 1120,
	"./tools/settings.js": 1121,
	"./tools/sprites.js": 1122
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1036;